import { ref } from 'vue'

// The legacy Ionic alert lives outside the money route and survives navController.back().
export const moneySuccessMessage = ref('')
export function closeMoneySuccess() { moneySuccessMessage.value = '' }
